import { Grid, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component, useMemo } from 'react';
import { connect, useSelector } from 'react-redux';
import ButtonConsultation from '/@/components/ask-an-expert/button';
import CardField from '/@/components/ask-an-expert/card-field';
import PopupMap from '/@/components/ask-an-expert/popup-map';
import PopupSendStatus from '/@/components/ask-an-expert/popup-send-status';
import Icon from '/@/components/icon';
import Spinner from '/@/components/spinner';
import settings from '/@/core/settings';
import { useMyFields } from '/@/hooks/fields/index.js';
import { _ } from '/@/locale';
import { getZonesFromAPI } from '/@/store/public-data/apiProviders.js';
import { getAppInstance, getSessionCountry, getSessionLanguage, getUser } from '/@/store/session/selectors';
import { mpTrackEvent } from '/@/store/tracking/mixpanel-events.js';
import { isMobile } from '/@/utils';
import Toggle from '/@/v3/components/forms/toggle/index.js';
import Title from '/@/v3/components/title';
import * as categoriesAR from './notes/ar';
import * as categoriesBR from './notes/br';
import * as categoriesMX from './notes/mx';
import * as categoriesPY from './notes/py';
import * as categoriesUY from './notes/uy';
import styles from './styles.module.css';

const DEFAULT_NOTE = categoriesAR;
const NOTES = {
    AR: categoriesAR,
    BR: categoriesBR,
    MX: categoriesMX,
    PY: categoriesPY,
    UY: categoriesUY,
};

const initialState = {
    showSubcategory: false,
    subcategories: [],
    loading: false,
    isEdit: false,
    showFields: false,
    selectedOption: '',
    selectedField: '',
    textInput: '',
    showIconText: true,
    hasFieldSelected: false,
    selectedCategory: '',
    selectedSubcategory: '',
    field: '',
    location: '',
    issuePartCategory: '',
    issuePartSubcategory: '',
    issuePartField: '',
    issuePartLocation: '',
    showPopupMap: false,
    selectedFile: null,
    sending: false,
    mdaZone: undefined,
    showMdaInvalidZone: false,
    showModalSendStatus: false,
    error: false,
    disabledButtonSend: true,
    showHelpTextForFile: true,
};
@connect((state, props) => {
    return {
        country: getSessionCountry(state),
        language: getSessionLanguage(state),
        user: getUser(state),
        isMobile: isMobile(),
        appInstance: getAppInstance(state),
    };
})
@autobind
class Consultation extends Component {
    constructor(props) {
        super(props);
        this.state = initialState;
    }

    static propTypes = {
        theme: PropTypes.oneOf(['latijereta', 'cultivio', 'agroceres', 'agroeste', 'md', 'expertobayer', 'fieldview']),
    };

    static contextTypes = {
        history: PropTypes.object,
    };

    componentDidMount() {
        this.setState({
            field: (this.props.defaultField && this.props.defaultField.name) || '',
            location: (this.props.defaultField && this.props.defaultField.location) || '',
            issuePartField: (this.props.defaultField && `// ${this.props.defaultField.name} `) || '',
            issuePartLocation: (this.props.defaultField && `// ${this.props.defaultField.location} `) || '',
            selectedOption: 'option-2',
            showFields: true,
            textInput: '',
            showIconText: true,
            hasFieldSelected: this.props.dataField === 'no-field' || ':dataField' ? false : true,
            selectedField: (this.props.defaultField && this.props.defaultField.name) || '',
            showPopupMap: false,
            sending: false,
            showModalSendStatus: false,
            error: false,
            disabledButtonSend: true,
            showHelpTextForFile: true,
            mdaZone: this.props.defaultField && this.props.defaultField.node.zones.find((zone) => zone.type === 'mda'),
        });
    }

    componentWillUnmount() {
        this.reset();
    }

    reset() {
        this.setState(initialState);
    }

    handleClickCategory(itemCategory) {
        const hasSubcategories = itemCategory.subcategories.length > 0;
        this.setState({
            showSubcategory: hasSubcategories,
            subcategories: itemCategory.subcategories,
            issuePartCategory: hasSubcategories ? `${_(itemCategory.category)} - ` : `${_(itemCategory.category)} `,
            selectedCategory: itemCategory,
            selectedSubcategory: '',
            issuePartSubcategory: '',
        });
    }

    handleClickSubcategory(itemSubcategory) {
        this.setState({
            issuePartSubcategory: ` ${_(itemSubcategory.subcategory)} `,
            selectedSubcategory: itemSubcategory,
        });
    }

    async handleSend() {
        this.setState({ sending: true });
        try {
            const issue = `${this.state.issuePartCategory}${this.state.issuePartSubcategory}${this.state.issuePartField}${this.state.issuePartLocation}`;
            const data = new FormData();
            data.append('file', this.state.selectedFile);
            data.append('app_instance', this.props.appInstance.id);
            data.append('note', issue);
            data.append('title', this.state.textInput);
            if (this.state.selectedCategory.id !== 'App') data.append('mda', this.state.mdaZone.codename);
            data.append('category', this.state.selectedCategory.id);
            data.append('subcategory', this.state.selectedSubcategory.id);

            const response = await fetch(settings.urls.askAnExpert.upload, {
                method: 'POST',
                body: data,
            });

            const responseJson = await response.json();
            this.setState(
                {
                    sending: false,
                    error: responseJson.status !== 200,
                    showModalSendStatus: true,
                },
                () => {
                    !this.state.error && setTimeout(this.reset, 3000);
                }
            );
            mpTrackEvent('Question sent to AskAnExpert', {
                status: responseJson.status !== 200 ? 'fail' : 'success',
                category: this.state.selectedCategory.id,
                subcategory: this.state.selectedSubcategory.id,
            });
        } catch (error) {
            mpTrackEvent('Question sent to AskAnExpert', {
                status: 'fail',
            });
            console.log('Error en el envío: ', error);
            this.setState({
                sending: false,
                error: true,
                showModalSendStatus: true,
            });
        }
    }

    handleFileSelected(event) {
        this.setState({
            selectedFile: event.target.files[0],
            showHelpTextForFile: false,
        });
    }

    handleEdit() {
        this.setState(this.state.isEdit ? { isEdit: false } : { isEdit: true });
    }

    handleChangeField(field) {
        const mdaZone = field.node.zones.find((zone) => zone.type === 'mda');
        this.setState({
            selectedField: field.name,
            location: field.location,
            field: field.name,
            issuePartLocation: `// ${field.location} `,
            issuePartField: `// ${field.name} `,
            mdaZone,
        });
    }

    handleChangeText(event) {
        this.setState({
            textInput: event.target.value,
        });
    }

    handleOnChangeRadioMap(changeEvent) {
        this.setState({
            selectedOption: changeEvent,
            showFields: false,
            showPopupMap: true,
            mdaZone: undefined,
            issuePartField: '',
        });
    }

    handleOnChangeRadioList(changeEvent) {
        this.setState({
            selectedOption: changeEvent,
            showFields: true,
        });
    }

    handleCleanFile() {
        this.setState({
            selectedFile: null,
            showHelpTextForFile: true,
        });
    }

    renderTitle() {
        const { isMobile } = this.props;
        return (
            <div className={classNames(styles.container, styles.titleConsult)}>
                <Title className={styles.titleAsk} bolder>
                    {_('Consulta')}
                </Title>
                {this.state.hasFieldSelected && !isMobile && this.renderButtonEdit()}
            </div>
        );
    }

    renderButtonEdit() {
        const { isMobile } = this.props;
        return (
            <div className={isMobile ? styles.buttonAskEdit : ''}>
                <Button variant='outlined' onClick={() => this.handleEdit()}>
                    {_(this.state.isEdit ? 'cancelar' : 'Cambiar lote')}
                </Button>
            </div>
        );
    }

    renderFieldsAndMap() {
        return (
            <div>
                <Title bolder className={classNames(styles.titleContainer, styles.titleAskTwo)}>
                    {_('Marcá un punto en el mapa, ó elegí uno de tus lotes para una mejor atención.')}
                </Title>
                <div className={classNames(styles.radioTitle, styles.titleContainer)}>
                    <label className={styles.radio}>
                        <Toggle
                            type='radio'
                            checked={this.state.selectedOption === 'option-1'}
                            value={this.state.selectedOption === 'option-1'}
                            onChange={() => this.handleOnChangeRadioMap('option-1')}
                            theme={settings.app.theme}
                            small
                        />
                        <span className={styles.radioLabel}>
                            <Title className={styles.titleRadioInput}>{_('Marcá un punto en el mapa')}</Title>
                        </span>
                    </label>
                </div>
                <div className={classNames(styles.radioTitle, styles.titleContainer)}>
                    <label className={styles.radio}>
                        <span className={styles.radioInput}>
                            <Toggle
                                type='radio'
                                checked={this.state.selectedOption === 'option-2'}
                                value={this.state.selectedOption === 'option-2'}
                                onChange={() => this.handleOnChangeRadioList('option-2')}
                                theme={settings.app.theme}
                                small
                            />
                        </span>
                        <span className={styles.radioLabel}>
                            <Title className={styles.titleRadioInput}>{_('Listado de mis lotes')}</Title>
                        </span>
                    </label>
                </div>
                <div>
                    {this.state.showFields ? (
                        this.props.fields?.length > 0 ? (
                            <div className={styles.containerCardsSlide}>
                                <Grid container>
                                    {this.props.fields.map((field) => {
                                        return (
                                            <Grid item xs={3}>
                                                <CardField
                                                    key={field.id}
                                                    name={field.name}
                                                    handleClick={() => this.handleChangeField(field)}
                                                    selected={this.state.selectedField}
                                                />
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            </div>
                        ) : (
                            <div className={styles.container}>
                                <Title className={styles.titleAskTwo}>{_('Todavía no creaste ningún lote')}</Title>
                            </div>
                        )
                    ) : null}
                </div>
            </div>
        );
    }

    renderField() {
        return (
            <div className={styles.containerField}>
                <Title className={styles.titleField}>{this.state.field}</Title>
            </div>
        );
    }

    renderCategories() {
        const note = NOTES[this.props.country.code] || DEFAULT_NOTE;
        const categories = note[`categories${this.props.country.code}`];
        return (
            <div className={styles.container}>
                <Title className={classNames(styles.titleContainer, styles.titleAskTwo)} bolder>
                    {_('Elegí la categoría de tu consulta')}
                </Title>
                <div className={styles.containerButtons}>
                    {categories.map((item, key) => {
                        return (
                            <ButtonConsultation
                                root50={true}
                                selected={this.state.selectedCategory.category}
                                icon={item.icon}
                                name={item.category}
                                color={item.color}
                                key={key}
                                handleClick={() => this.handleClickCategory(item)}
                            />
                        );
                    })}
                </div>
            </div>
        );
    }

    renderSubcategories() {
        const subcategories = this.state.subcategories;
        return (
            <div className={styles.container}>
                <Title className={classNames(styles.titleContainer, styles.titleAskTwo)} bolder>
                    {_('Danos más detalles de tu consulta para una mejor asistencia')}
                </Title>
                <div className={styles.containerButtons}>
                    {subcategories.map((item, key) => {
                        return (
                            <ButtonConsultation
                                root50={false}
                                selected={this.state.selectedSubcategory.subcategory}
                                icon={item.icon}
                                name={item.subcategory}
                                color={item.color}
                                key={key}
                                handleClick={() => this.handleClickSubcategory(item)}
                            />
                        );
                    })}
                </div>
            </div>
        );
    }

    renderIssue() {
        const { isMobile } = this.props;
        return (
            <div className={styles.containerIssue}>
                <div className={styles.issue}>
                    <Title size='md' className={styles.textTitleIssue}>
                        <span>{_('Asunto:')}</span>
                        {` ${this.state.issuePartCategory}${this.state.issuePartSubcategory}${this.state.issuePartField}${this.state.issuePartLocation}`}
                    </Title>
                </div>
                <div
                    className={classNames(styles.textIssue, styles.cursorText, 'mp-mask')}
                    onClick={() => {
                        this.setState({ showIconText: false });
                    }}
                >
                    <div className={styles.buttons}>
                        {this.state.showIconText ? (
                            <Icon type={'pen'} size='xs' className={styles.iconColor} />
                        ) : (
                            <textarea
                                rows='8'
                                cols='80'
                                onChange={(event) => this.handleChangeText(event)}
                                value={this.state.textInput}
                                className={styles.inputText}
                                autoFocus
                            />
                        )}
                    </div>
                </div>
                <div className={styles.buttonIssue}>
                    <div className={styles.upload}>
                        <div className={styles.uploadFile}>
                            <div className={styles.iconPosition}>
                                <Icon type={'clip'} size='xs' className={styles.iconColor} />
                            </div>
                            <div className={styles.inputContainer}>
                                <input
                                    type='file'
                                    onChange={(event) => this.handleFileSelected(event)}
                                    className={classNames(styles.inputFile, styles.inputFileFile)}
                                />
                            </div>
                            {this.state.showHelpTextForFile && (
                                <div className={styles.helpTextForFile}>
                                    <Title className={classNames(styles.iconColor, styles.helpText)}>
                                        {_(
                                            'Podés adjuntar hasta 1 archivo. Si necesitas adjuntar más, podes comprimir una carpeta.'
                                        )}
                                    </Title>
                                </div>
                            )}
                        </div>
                        {this.state.selectedFile && (
                            <div className={styles.file}>
                                <i className='material-icons'>description</i>
                                <span>{this.state.selectedFile.name}</span>
                                <i
                                    className={classNames('material-icons', styles.iconClickable)}
                                    onClick={(event) => this.handleCleanFile(event)}
                                >
                                    delete_outline
                                </i>
                            </div>
                        )}
                    </div>
                    {!isMobile && this.renderSendButton()}
                </div>
            </div>
        );
    }

    handleIsEnabled() {
        const { mdaZone, textInput } = this.state;
        if (this.state.selectedCategory.id === 'App' && textInput.length > 0) {
            return true;
        }
        return mdaZone && mdaZone.codename.length > 0 && textInput.length > 0;
    }

    renderSendButton() {
        const { isMobile } = this.props;
        const isEnabled = this.handleIsEnabled();
        return (
            <div className={isMobile ? styles.buttonMobile : styles.buttonIssue}>
                <Button variant='contained' onClick={this.handleSend} disabled={!isEnabled}>
                    {this.state.sending ? _('Enviando...') : _('Enviar')}
                </Button>
            </div>
        );
    }

    handleOnClosePopupmap() {
        this.setState({
            showPopupMap: false,
        });
    }

    handleOnClosePopupSendStatus() {
        this.setState({
            showModalSendStatus: false,
            error: false,
        });
    }

    async setMdaZone(point) {
        const [lng, lat] = point;
        const zones = await getZonesFromAPI({
            lng,
            lat,
            type: 'mda',
        });

        if (!zones) this.setState({ showMdaInvalidZone: true });
        else
            this.setState({
                mdaZone: {
                    ...zones?.[0],
                    geometry: [point],
                    iconType: 'mda',
                    _id: String(lng),
                },
                showMdaInvalidZone: false,
                issuePartLocation: zones?.[0].codename,
            });
    }

    render() {
        const { isMobile } = this.props;
        return (
            <div className={styles.root}>
                <div className={styles.consult}>
                    {this.renderTitle()}
                    {this.state.hasFieldSelected && this.renderField()}
                    {this.state.hasFieldSelected && isMobile && this.renderButtonEdit()}
                    {this.state.selectedCategory.id !== 'App' &&
                        this.state.hasFieldSelected &&
                        this.state.isEdit &&
                        this.renderFieldsAndMap()}
                    {this.renderCategories()}
                    {this.state.showSubcategory && this.renderSubcategories()}
                    {this.state.selectedCategory.id !== 'App' &&
                        !this.state.hasFieldSelected &&
                        this.renderFieldsAndMap()}
                    {this.renderIssue()}
                    {isMobile && this.renderSendButton()}
                </div>
                {this.props.children}
                <PopupMap
                    visible={this.state.showPopupMap}
                    onClose={this.handleOnClosePopupmap}
                    fields={this.state.mdaZone ? [this.state.mdaZone] : []}
                    zoomPosition='BOTTOM_RIGHT'
                    country={this.props.country}
                    onSelect={this.setMdaZone}
                    showErrorBanner={this.state.showMdaInvalidZone}
                />
                <PopupSendStatus
                    visible={this.state.showModalSendStatus}
                    onClose={this.handleOnClosePopupSendStatus}
                    error={this.state.error}
                    reSendPost={this.handleSend}
                    showCloseIcon={this.state.error}
                />
            </div>
        );
    }
}

const ConsultationWrapper = (props: any) => {
    const country = useSelector(getSessionCountry);
    const fieldsQuery = useMyFields({
        page: 1,
        pageSize: 10000,
        country: country.code,
        selectOnly: 'id,lat,lng,name,location,node',
    });

    const defaultField = useMemo(
        () => fieldsQuery.data?.results.find((f) => f.id === props.dataField),
        [fieldsQuery.data?.results, props.dataField]
    );
    if (fieldsQuery.isValidating)
        return (
            <Stack justifyContent='center' alignItems='center' my={2}>
                <Spinner />
            </Stack>
        );

    return <Consultation {...props} fields={fieldsQuery.data?.results} defaultField={defaultField} />;
};

export default ConsultationWrapper;
